<template lang="pug">
  nav.navbar.navbar-expand-md.secondary-navbar
    .container.flex-column.flex-md-row.align-items-stretch
      button.navbar-toggler.text-left(type="button" data-toggle="collapse" data-target="#secondary_nav")
        i.fa.fa-bars.fa-fw.mr-1
        | {{selectedCategory ? selectedCategory.name : 'Все'}}

      #secondary_nav.collapse.navbar-collapse(ref="collapse")
        ul.navbar-nav
          li.nav-item(v-for="category in categoriesWithAll" :key="category.slug")
            a.position-relative(
              href="#"
              @click.prevent="selectedCategorySlug = category.slug"
              :class="{ active: selectedCategorySlug === category.slug }"
            ) {{category.name}}

      ul.navbar-filters
        li.nav-item
          SearchInput(v-model="search")

        li.nav-item
          .dropdown
            a(href="#" data-toggle="dropdown") Автор:#{' '}
              span.selected-filter
                | {{selectedAuthor ? selectedAuthor.name : 'Все'}}
                i.fa.fa-angle-down.ml-1

            .dropdown-menu.dropdown-menu-right
              a.dropdown-item(
                v-for="author in authorsWithAll"
                href="#"
                @click.prevent="selectedAuthorSlug = author.slug"
                :class="{ active: selectedAuthorSlug === author.slug }"
              ) {{author.name}}

        li.nav-item
          CurrencySelector

</template>

<script>
  import { toRefs, computed } from '@vue/composition-api';

  import { state as globalState } from '@app/edu_materials/stores/global-store';
  import { state as indexState } from '@app/edu_materials/stores/index-store';

  import SearchInput from '@app/edu_materials/components/index/SearchInput';
  import CurrencySelector from '@app_shared/components/CurrencySelector';

  export default {
    components: {
      SearchInput,
      CurrencySelector,
    },

    setup () {
      const { selectedCategory, selectedCategorySlug, selectedAuthor, selectedAuthorSlug, search } = toRefs(indexState);

      return {
        authorsWithAll: computed(() => [{ slug: undefined, name: 'Все' }, ...globalState.authors]),
        selectedAuthor,
        selectedAuthorSlug,

        categoriesWithAll: computed(() => [{ slug: undefined, name: 'Все' }, ...globalState.categories]),
        selectedCategorySlug,
        selectedCategory,

        search,
      };
    },
  };
</script>